<template>   
<div id="app">     <router-view />   
</div> </template>

<script>
export default {
  name: "App",
};
</script>

<style>
/*#app {*/
/*  font-family: Avenir, Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
  /* text-align: center; */
/*  color: #2c3e50;*/
/*}*/
:root {
  --lineColor: #e6e6e6;
}

* {
  box-sizing: border-box;
}

.tox-tinymce-inline {
  z-index: 300;
}

#app {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.title_window {
  width: 100%;
  height: 30px;
  background: #f5f5f7;
  -webkit-app-region: drag;
  float: left;
  display: flex;
}

.title_window div {
  -webkit-app-region: no-drag;
}

.el-dialog.digital-textbook-dialog {
  box-shadow: 0px 10px 30px 0px rgba(139, 150, 175, 0.6);
}

.digital-textbook-dialog .el-dialog__body {
  max-height: 457px;
  overflow: auto;
}

.line-dialog {
  .el-dialog__header {
    height: 27px;
    border-bottom: 1px solid var(--lineColor);
    padding-top: 27px !important;
  }

  .el-dialog__headerbtn {
    top: 6px;
    right: 12px;
  }
}

.heimgfont,
.he-control-bar {
  background-color: #191919 !important;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: #c0c0c0;
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background-color: transparent !important;
}

.el-dialog .el-dialog__header {
  border-bottom: 1px solid #e6e6e6;
}

.el-dialog .el-dialog__headerbtn {
  top: 10px;
}

.el-icon-info.icon-error {
  color: #f34d4d;
  font-size: 14px;
  margin-top: 1px;
}

.search-highlight  {
  padding: 2px 5px;
  color: #F18130;
  background: #FEF2EA;
}

/* 消息高亮 */
.highlight-message {
  background: #EEF2FF;
  border: 1px solid #5584FB !important;
  transition: all 0.3s ease;
}

</style>
